/* tslint:disable */
/* eslint-disable */
/**
 * acomo API docs
 * acomoのAPI仕様書です。
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  CreateProcessFileDto,
  ListWorkflowProcessesResult,
  ProcessHistoryDiffEntity,
  ProcessWithNodeActionsEntity,
  WorkflowProcessEntity,
} from '../models/index';
import {
    CreateProcessFileDtoFromJSON,
    CreateProcessFileDtoToJSON,
    ListWorkflowProcessesResultFromJSON,
    ListWorkflowProcessesResultToJSON,
    ProcessHistoryDiffEntityFromJSON,
    ProcessHistoryDiffEntityToJSON,
    ProcessWithNodeActionsEntityFromJSON,
    ProcessWithNodeActionsEntityToJSON,
    WorkflowProcessEntityFromJSON,
    WorkflowProcessEntityToJSON,
} from '../models/index';

export interface DeleteMyProcessDataFileRequest {
    processId: string;
    createProcessFileDto: CreateProcessFileDto;
}

export interface GetMyDiffsRequest {
    processId: string;
}

export interface GetMyProcessDataFileDownloadUrlRequest {
    processId: string;
    disposition: string;
    createProcessFileDto: CreateProcessFileDto;
}

export interface GetMyProcessesRequest {
    processId: string;
    processHistoryType?: string;
    nodeActionType?: string;
    actioned?: boolean;
    permitted?: boolean;
}

export interface GetMyProcessesWithNodeIdRequest {
    processId: string;
    nodeId: string;
    processHistoryType?: string;
    nodeActionType?: string;
    actioned?: boolean;
    permitted?: boolean;
}

export interface GetProcessWithNodeActionsRequest {
    processId: string;
    processHistoryType?: string;
    nodeActionType?: string;
    actioned?: boolean;
    permitted?: boolean;
}

export interface GetProcessWithSpecificNodeActionsRequest {
    processId: string;
    nodeId: string;
    processHistoryType?: string;
    nodeActionType?: string;
    actioned?: boolean;
    permitted?: boolean;
}

export interface ListMyProcessesRequest {
    processHistoryType?: string;
    nodeActionType?: string;
    actioned?: boolean;
    permitted?: boolean;
    filter?: string;
    skip?: string;
    take?: string;
}

export interface ListProcessWithNodeActionsRequest {
    processHistoryType?: string;
    nodeActionType?: string;
    actioned?: boolean;
    permitted?: boolean;
    filter?: string;
    skip?: string;
    take?: string;
}

export interface UploadMyProcessDataFileRequest {
    processId: string;
    createProcessFileDto: CreateProcessFileDto;
}

/**
 * 
 */
export class MyProcessApi extends runtime.BaseAPI {

    /**
     * 自身のプロセスデータに紐づいた指定のファイルを削除する
     */
    async deleteMyProcessDataFileRaw(requestParameters: DeleteMyProcessDataFileRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<object>> {
        if (requestParameters['processId'] == null) {
            throw new runtime.RequiredError(
                'processId',
                'Required parameter "processId" was null or undefined when calling deleteMyProcessDataFile().'
            );
        }

        if (requestParameters['createProcessFileDto'] == null) {
            throw new runtime.RequiredError(
                'createProcessFileDto',
                'Required parameter "createProcessFileDto" was null or undefined when calling deleteMyProcessDataFile().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-tenant-id"] = await this.configuration.apiKey("x-tenant-id"); // Tenant authentication
        }

        const response = await this.request({
            path: `/api/v1/my/processes/{processId}/files/delete`.replace(`{${"processId"}}`, encodeURIComponent(String(requestParameters['processId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateProcessFileDtoToJSON(requestParameters['createProcessFileDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * 自身のプロセスデータに紐づいた指定のファイルを削除する
     */
    async deleteMyProcessDataFile(requestParameters: DeleteMyProcessDataFileRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<object> {
        const response = await this.deleteMyProcessDataFileRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 指定したIDのワークフロープロセスに関連する履歴の差分を取得する。
     */
    async getMyDiffsRaw(requestParameters: GetMyDiffsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ProcessHistoryDiffEntity>>> {
        if (requestParameters['processId'] == null) {
            throw new runtime.RequiredError(
                'processId',
                'Required parameter "processId" was null or undefined when calling getMyDiffs().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-tenant-id"] = await this.configuration.apiKey("x-tenant-id"); // Tenant authentication
        }

        const response = await this.request({
            path: `/api/v1/my/processes/{processId}/diffs`.replace(`{${"processId"}}`, encodeURIComponent(String(requestParameters['processId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ProcessHistoryDiffEntityFromJSON));
    }

    /**
     * 指定したIDのワークフロープロセスに関連する履歴の差分を取得する。
     */
    async getMyDiffs(requestParameters: GetMyDiffsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ProcessHistoryDiffEntity>> {
        const response = await this.getMyDiffsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 自身のプロセスに紐づいた指定のファイルの一時ダウンロードURLを発行する（有効期限15分）
     */
    async getMyProcessDataFileDownloadUrlRaw(requestParameters: GetMyProcessDataFileDownloadUrlRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>> {
        if (requestParameters['processId'] == null) {
            throw new runtime.RequiredError(
                'processId',
                'Required parameter "processId" was null or undefined when calling getMyProcessDataFileDownloadUrl().'
            );
        }

        if (requestParameters['disposition'] == null) {
            throw new runtime.RequiredError(
                'disposition',
                'Required parameter "disposition" was null or undefined when calling getMyProcessDataFileDownloadUrl().'
            );
        }

        if (requestParameters['createProcessFileDto'] == null) {
            throw new runtime.RequiredError(
                'createProcessFileDto',
                'Required parameter "createProcessFileDto" was null or undefined when calling getMyProcessDataFileDownloadUrl().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['disposition'] != null) {
            queryParameters['disposition'] = requestParameters['disposition'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-tenant-id"] = await this.configuration.apiKey("x-tenant-id"); // Tenant authentication
        }

        const response = await this.request({
            path: `/api/v1/my/processes/{processId}/files/getDownloadUrl`.replace(`{${"processId"}}`, encodeURIComponent(String(requestParameters['processId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateProcessFileDtoToJSON(requestParameters['createProcessFileDto']),
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<string>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * 自身のプロセスに紐づいた指定のファイルの一時ダウンロードURLを発行する（有効期限15分）
     */
    async getMyProcessDataFileDownloadUrl(requestParameters: GetMyProcessDataFileDownloadUrlRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string | null | undefined > {
        const response = await this.getMyProcessDataFileDownloadUrlRaw(requestParameters, initOverrides);
        switch (response.raw.status) {
            case 200:
                return await response.value();
            case 201:
                return null;
            default:
                return await response.value();
        }
    }

    /**
     * 自分自身がアクション可能、またはアクションしたプロセスを一件取得する。
     */
    async getMyProcessesRaw(requestParameters: GetMyProcessesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<WorkflowProcessEntity>> {
        if (requestParameters['processId'] == null) {
            throw new runtime.RequiredError(
                'processId',
                'Required parameter "processId" was null or undefined when calling getMyProcesses().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['processHistoryType'] != null) {
            queryParameters['processHistoryType'] = requestParameters['processHistoryType'];
        }

        if (requestParameters['nodeActionType'] != null) {
            queryParameters['nodeActionType'] = requestParameters['nodeActionType'];
        }

        if (requestParameters['actioned'] != null) {
            queryParameters['actioned'] = requestParameters['actioned'];
        }

        if (requestParameters['permitted'] != null) {
            queryParameters['permitted'] = requestParameters['permitted'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-tenant-id"] = await this.configuration.apiKey("x-tenant-id"); // Tenant authentication
        }

        const response = await this.request({
            path: `/api/v1/my/processes/{processId}`.replace(`{${"processId"}}`, encodeURIComponent(String(requestParameters['processId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => WorkflowProcessEntityFromJSON(jsonValue));
    }

    /**
     * 自分自身がアクション可能、またはアクションしたプロセスを一件取得する。
     */
    async getMyProcesses(requestParameters: GetMyProcessesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<WorkflowProcessEntity> {
        const response = await this.getMyProcessesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 自分自身がアクション可能、またはアクションしたプロセスを一件取得する。       アクション可能なノードと可能アクションのうち、指定したnodeIdのもののみ取得する。       permitted=trueの場合、指定したnodeIdでアクション可能なプロセスのみ取得する。
     * 自分自身がアクション可能、またはアクションしたプロセスを一件取得する。
     */
    async getMyProcessesWithNodeIdRaw(requestParameters: GetMyProcessesWithNodeIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<WorkflowProcessEntity>> {
        if (requestParameters['processId'] == null) {
            throw new runtime.RequiredError(
                'processId',
                'Required parameter "processId" was null or undefined when calling getMyProcessesWithNodeId().'
            );
        }

        if (requestParameters['nodeId'] == null) {
            throw new runtime.RequiredError(
                'nodeId',
                'Required parameter "nodeId" was null or undefined when calling getMyProcessesWithNodeId().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['processHistoryType'] != null) {
            queryParameters['processHistoryType'] = requestParameters['processHistoryType'];
        }

        if (requestParameters['nodeActionType'] != null) {
            queryParameters['nodeActionType'] = requestParameters['nodeActionType'];
        }

        if (requestParameters['actioned'] != null) {
            queryParameters['actioned'] = requestParameters['actioned'];
        }

        if (requestParameters['permitted'] != null) {
            queryParameters['permitted'] = requestParameters['permitted'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-tenant-id"] = await this.configuration.apiKey("x-tenant-id"); // Tenant authentication
        }

        const response = await this.request({
            path: `/api/v1/my/processes/{processId}/{nodeId}`.replace(`{${"processId"}}`, encodeURIComponent(String(requestParameters['processId']))).replace(`{${"nodeId"}}`, encodeURIComponent(String(requestParameters['nodeId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => WorkflowProcessEntityFromJSON(jsonValue));
    }

    /**
     * 自分自身がアクション可能、またはアクションしたプロセスを一件取得する。       アクション可能なノードと可能アクションのうち、指定したnodeIdのもののみ取得する。       permitted=trueの場合、指定したnodeIdでアクション可能なプロセスのみ取得する。
     * 自分自身がアクション可能、またはアクションしたプロセスを一件取得する。
     */
    async getMyProcessesWithNodeId(requestParameters: GetMyProcessesWithNodeIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<WorkflowProcessEntity> {
        const response = await this.getMyProcessesWithNodeIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 自分自身がアクション可能、またはアクションしたプロセス一件をアクション可能なノードとアクションとあわせて取得する。
     */
    async getProcessWithNodeActionsRaw(requestParameters: GetProcessWithNodeActionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ProcessWithNodeActionsEntity>> {
        if (requestParameters['processId'] == null) {
            throw new runtime.RequiredError(
                'processId',
                'Required parameter "processId" was null or undefined when calling getProcessWithNodeActions().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['processHistoryType'] != null) {
            queryParameters['processHistoryType'] = requestParameters['processHistoryType'];
        }

        if (requestParameters['nodeActionType'] != null) {
            queryParameters['nodeActionType'] = requestParameters['nodeActionType'];
        }

        if (requestParameters['actioned'] != null) {
            queryParameters['actioned'] = requestParameters['actioned'];
        }

        if (requestParameters['permitted'] != null) {
            queryParameters['permitted'] = requestParameters['permitted'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-tenant-id"] = await this.configuration.apiKey("x-tenant-id"); // Tenant authentication
        }

        const response = await this.request({
            path: `/api/v1/my/processes/nodeActions/{processId}`.replace(`{${"processId"}}`, encodeURIComponent(String(requestParameters['processId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ProcessWithNodeActionsEntityFromJSON(jsonValue));
    }

    /**
     * 自分自身がアクション可能、またはアクションしたプロセス一件をアクション可能なノードとアクションとあわせて取得する。
     */
    async getProcessWithNodeActions(requestParameters: GetProcessWithNodeActionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ProcessWithNodeActionsEntity> {
        const response = await this.getProcessWithNodeActionsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 自分自身がアクション可能、またはアクションしたプロセス一件をアクション可能なノードとアクションとあわせて取得する。       permitted=trueかつnodeIdを指定した場合、指定したnodeIdでアクション可能なプロセスのみ取得する。
     * 自分自身がアクション可能、またはアクションしたプロセス一件をアクション可能なノードとアクションとあわせて取得する。
     */
    async getProcessWithSpecificNodeActionsRaw(requestParameters: GetProcessWithSpecificNodeActionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ProcessWithNodeActionsEntity>> {
        if (requestParameters['processId'] == null) {
            throw new runtime.RequiredError(
                'processId',
                'Required parameter "processId" was null or undefined when calling getProcessWithSpecificNodeActions().'
            );
        }

        if (requestParameters['nodeId'] == null) {
            throw new runtime.RequiredError(
                'nodeId',
                'Required parameter "nodeId" was null or undefined when calling getProcessWithSpecificNodeActions().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['processHistoryType'] != null) {
            queryParameters['processHistoryType'] = requestParameters['processHistoryType'];
        }

        if (requestParameters['nodeActionType'] != null) {
            queryParameters['nodeActionType'] = requestParameters['nodeActionType'];
        }

        if (requestParameters['actioned'] != null) {
            queryParameters['actioned'] = requestParameters['actioned'];
        }

        if (requestParameters['permitted'] != null) {
            queryParameters['permitted'] = requestParameters['permitted'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-tenant-id"] = await this.configuration.apiKey("x-tenant-id"); // Tenant authentication
        }

        const response = await this.request({
            path: `/api/v1/my/processes/nodeActions/{processId}/{nodeId}`.replace(`{${"processId"}}`, encodeURIComponent(String(requestParameters['processId']))).replace(`{${"nodeId"}}`, encodeURIComponent(String(requestParameters['nodeId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ProcessWithNodeActionsEntityFromJSON(jsonValue));
    }

    /**
     * 自分自身がアクション可能、またはアクションしたプロセス一件をアクション可能なノードとアクションとあわせて取得する。       permitted=trueかつnodeIdを指定した場合、指定したnodeIdでアクション可能なプロセスのみ取得する。
     * 自分自身がアクション可能、またはアクションしたプロセス一件をアクション可能なノードとアクションとあわせて取得する。
     */
    async getProcessWithSpecificNodeActions(requestParameters: GetProcessWithSpecificNodeActionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ProcessWithNodeActionsEntity> {
        const response = await this.getProcessWithSpecificNodeActionsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 自分自身がアクション可能、またはアクションしたプロセスの一覧を取得する。
     */
    async listMyProcessesRaw(requestParameters: ListMyProcessesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListWorkflowProcessesResult>> {
        const queryParameters: any = {};

        if (requestParameters['processHistoryType'] != null) {
            queryParameters['processHistoryType'] = requestParameters['processHistoryType'];
        }

        if (requestParameters['nodeActionType'] != null) {
            queryParameters['nodeActionType'] = requestParameters['nodeActionType'];
        }

        if (requestParameters['actioned'] != null) {
            queryParameters['actioned'] = requestParameters['actioned'];
        }

        if (requestParameters['permitted'] != null) {
            queryParameters['permitted'] = requestParameters['permitted'];
        }

        if (requestParameters['filter'] != null) {
            queryParameters['filter'] = requestParameters['filter'];
        }

        if (requestParameters['skip'] != null) {
            queryParameters['skip'] = requestParameters['skip'];
        }

        if (requestParameters['take'] != null) {
            queryParameters['take'] = requestParameters['take'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-tenant-id"] = await this.configuration.apiKey("x-tenant-id"); // Tenant authentication
        }

        const response = await this.request({
            path: `/api/v1/my/processes`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ListWorkflowProcessesResultFromJSON(jsonValue));
    }

    /**
     * 自分自身がアクション可能、またはアクションしたプロセスの一覧を取得する。
     */
    async listMyProcesses(requestParameters: ListMyProcessesRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListWorkflowProcessesResult> {
        const response = await this.listMyProcessesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 自分自身がアクション可能、またはアクションしたプロセスの一覧をアクション可能なノードとアクションとあわせて取得する。
     */
    async listProcessWithNodeActionsRaw(requestParameters: ListProcessWithNodeActionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ProcessWithNodeActionsEntity>>> {
        const queryParameters: any = {};

        if (requestParameters['processHistoryType'] != null) {
            queryParameters['processHistoryType'] = requestParameters['processHistoryType'];
        }

        if (requestParameters['nodeActionType'] != null) {
            queryParameters['nodeActionType'] = requestParameters['nodeActionType'];
        }

        if (requestParameters['actioned'] != null) {
            queryParameters['actioned'] = requestParameters['actioned'];
        }

        if (requestParameters['permitted'] != null) {
            queryParameters['permitted'] = requestParameters['permitted'];
        }

        if (requestParameters['filter'] != null) {
            queryParameters['filter'] = requestParameters['filter'];
        }

        if (requestParameters['skip'] != null) {
            queryParameters['skip'] = requestParameters['skip'];
        }

        if (requestParameters['take'] != null) {
            queryParameters['take'] = requestParameters['take'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-tenant-id"] = await this.configuration.apiKey("x-tenant-id"); // Tenant authentication
        }

        const response = await this.request({
            path: `/api/v1/my/processes/nodeActions`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ProcessWithNodeActionsEntityFromJSON));
    }

    /**
     * 自分自身がアクション可能、またはアクションしたプロセスの一覧をアクション可能なノードとアクションとあわせて取得する。
     */
    async listProcessWithNodeActions(requestParameters: ListProcessWithNodeActionsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ProcessWithNodeActionsEntity>> {
        const response = await this.listProcessWithNodeActionsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 自身のプロセスデータに紐づいたファイルをアップロードする
     */
    async uploadMyProcessDataFileRaw(requestParameters: UploadMyProcessDataFileRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<object>> {
        if (requestParameters['processId'] == null) {
            throw new runtime.RequiredError(
                'processId',
                'Required parameter "processId" was null or undefined when calling uploadMyProcessDataFile().'
            );
        }

        if (requestParameters['createProcessFileDto'] == null) {
            throw new runtime.RequiredError(
                'createProcessFileDto',
                'Required parameter "createProcessFileDto" was null or undefined when calling uploadMyProcessDataFile().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-tenant-id"] = await this.configuration.apiKey("x-tenant-id"); // Tenant authentication
        }

        const response = await this.request({
            path: `/api/v1/my/processes/{processId}/files/upload`.replace(`{${"processId"}}`, encodeURIComponent(String(requestParameters['processId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateProcessFileDtoToJSON(requestParameters['createProcessFileDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * 自身のプロセスデータに紐づいたファイルをアップロードする
     */
    async uploadMyProcessDataFile(requestParameters: UploadMyProcessDataFileRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<object> {
        const response = await this.uploadMyProcessDataFileRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
